import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header-questionRulit',
  templateUrl: './header-questionRulit.component.html',
  styleUrls: ['./header-questionRulit.component.scss']
})
export class HeaderQuestionRulitComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
